import React, { useState } from 'react'

import axios from 'axios'
import useSWR from '../../../hooks/useSWR'
import NewEmailForm from './NewEmailForm'
import { dateFromObjectId, niceDateWithYear } from '../../../common/utils'
import useThrottledState from '../../../hooks/useThrottledState'

const Emails = () => {
  const [search, setSearch] = useThrottledState('')
  const [selectedEmail, setSelectedEmail] = useState(null)

  const { isValidating, data: list } = useSWR(search.length > 3 && search.includes('@') && '/subject/admin/s_emails', { search })

  const handleClick = async (email) => {
    const result = await axios.get(`${window.MYQLOCX_API}/subject/admin/s_emails/${email}`)
    setSelectedEmail(result.data)
  }

  return (
    <div>
      <br />
      <input type="text" placeholder="Email" onChange={(e) => setSearch(e.target.value)} />
      {isValidating && <div>Laddar...</div>}
      <br />
      {list && (
        <div>
          <h4>Denna användare har mottagit följande mail:</h4>
          {list.length === 0 && <div>Inga mail mottagna</div>}
          {list.map((email) => (
            <div key={email._id} style={{ background: '#fff', cursor: 'pointer', marginRight: 5, padding: 2, marginTop: 5 }} onClick={() => handleClick(email._id)}>
              Mottagare: {email.recipient} - Ämne: {email.subject} - Skapad: {niceDateWithYear(dateFromObjectId(email._id))} - Skickat: {email.consumed && niceDateWithYear(email.consumed)}
            </div>
          ))}
        </div>
      )}
      <br />

      {selectedEmail && <NewEmailForm selectedEmail={selectedEmail} isOpen={!!selectedEmail} closeModal={() => setSelectedEmail(false)} />}
    </div>
  )
}

export default Emails
